<section class="section page">
  <div class="section container-v2">
    <div class="grid-container cart-header">
      <sd-cart-header></sd-cart-header>
      <sd-cart-undo-delete-toast></sd-cart-undo-delete-toast>
    </div>

    @if (isBrowser && cart()) {
      @if (isEmptyCart()) {
        <sd-cart-empty></sd-cart-empty>
      } @else {
        <div class="grid-container">
          <sd-cart-list [entries]="entries()"></sd-cart-list>

          <sd-cart-totals [cart]="cart()"></sd-cart-totals>
        </div>

        <sd-product-carousel
          class="cart-product-carousel"
          data-testid="product-carousel-shopping-cart"
          [productIdsContext]="entriesCodes()"
          [position]="2"
        ></sd-product-carousel>
      }
    }
  </div>
</section>
